import { appendProtocol } from '@/postContentElement/components/utils/link';
import { usePostContentContext } from '@/postContentElement/context';
import { evaluateAndAppendUTMParams } from '@/utils/evaluateAndAppendUTMParams';

interface Props {
  anchorId?: string;
  postUrl?: string;
  screenshotUrl?: string;
}

const InstagramReel = ({ anchorId, postUrl, screenshotUrl }: Props) => {
  const { utmParams } = usePostContentContext();
  const postUrlWithUTMParams = evaluateAndAppendUTMParams(appendProtocol(postUrl), utmParams);

  return (
    <div id={anchorId} style={{ padding: '0.5rem 0.25rem' }}>
      <blockquote
        className="bh__ig_media mx-auto p-0 border border-[#d1d5db] bg-white hover:bg-[#f9fafb]"
        style={{
          maxWidth: '420px',
          minWidth: '326px',
          width: 'calc(100% - 2px)',
          borderRadius: '0.5rem',
        }}
      >
        <div>
          <a
            href={postUrlWithUTMParams}
            className="p-0 text-center w-full no-underline"
            target="_blank"
            rel="noreferrer"
          >
            <img src={screenshotUrl} alt="Instagram Reel" />
          </a>
        </div>
      </blockquote>
    </div>
  );
};

export { InstagramReel };
